import { Controller } from "@hotwired/stimulus"

// Animated counter that counts up when element comes into view
// Usage: data-controller="counter" data-counter-target-value="1000" data-counter-suffix-value="+"
export default class extends Controller {
  static values = {
    target: { type: Number, default: 0 },
    duration: { type: Number, default: 2000 },
    suffix: { type: String, default: "" },
    prefix: { type: String, default: "" }
  }

  connect() {
    this.hasAnimated = false
    this.element.textContent = this.prefixValue + "0" + this.suffixValue
    this.createObserver()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  createObserver() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.hasAnimated = true
            this.animate()
            this.observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.5 }
    )

    this.observer.observe(this.element)
  }

  animate() {
    const start = 0
    const end = this.targetValue
    const duration = this.durationValue
    const startTime = performance.now()

    const updateCounter = (currentTime) => {
      const elapsed = currentTime - startTime
      const progress = Math.min(elapsed / duration, 1)

      // Easing function (ease-out)
      const easeOut = 1 - Math.pow(1 - progress, 3)
      const current = Math.floor(start + (end - start) * easeOut)

      this.element.textContent = this.prefixValue + current.toLocaleString() + this.suffixValue

      if (progress < 1) {
        requestAnimationFrame(updateCounter)
      }
    }

    requestAnimationFrame(updateCounter)
  }
}
